<div (click)="openAIAgent()">
    <img src="../../../../../assets/images/ai-agent/Icon-AI-Agent.svg" class="ai-agent-icon" />

</div>

<app-chat-flyout [(isOpen)]="showAIAgent" [headerText]="'Ecolab Virtual Assistant'" [hideHistoryPanel]="calledFromFsqs"
    (isOpenChange)="closeAgentFlyout($event)" (onRightPanelToggle)="onToggleRightPanel($event)">
    <div panelHeader>
        <div class="new-chat-container" (click)="startNewChat()">
            <img src="../../../../assets/images/ai-agent/edit_square.svg" alt="New Chat" />
            <span class="new-chat-label">{{ 'AI_AGENT.NEW_CHAT' | translate }}</span>
        </div>

    </div>
    <div leftPanel class="col-12 chat-bot-container"> <!--*ngIf="contextPointId"-->
        <div class="chat-messages" #chatContainer>
            <div *ngIf="!calledFromFsqs"  class="col-lg-12 p-0" (click)="$event.stopPropagation()">
                <span class="pt-0 site-label">
                    {{ "Site" }}
                </span>
                <div class="search-container position-relative">
                    <div (click)="toggleSearchDropdown();" tabindex="0" #displaySiteLabel>
                        <span class="siteSearchBox"
                            [ngClass]="{'site-dropdown-shown' : displaySearch, 'non-editable': isSearchDropDownDisable, 'editable': !isSearchDropDownDisable }"
                            role="textbox" #element4 placement='bottom' title="selectedSearchDetails?.siteName">
                            <span class="selected-site">{{selectedSearchDetails?.Site ? selectedSearchDetails?.Site :
                                'Select Your Site' }}</span>
                        </span>
                    </div>
                    <div class="siteSearchDropdown" #siteSearchBar>
                        <nalco-search-bar-and-result *ngIf="displaySearch" [tabValue]="searchInputData?.SearchTabs[1]"
                            [searchData]="searchInputData" (selectedResult)="getSelectedSiteData($event)">
                        </nalco-search-bar-and-result>
                    </div>
                </div>
            </div>
            <div *ngIf="chipList.length && contextPointId" class="chip-list-container">
                <nalco-agent-chip-list [chipList]="chipList"
                    (chipSelectionChangeEmitter)="onChipSelection($event)"></nalco-agent-chip-list>
            </div>
            <div class="text-center default-chat-loader" *ngIf="isLoadingChat">
                <nalco-refresh-loader [isLoading]="isLoadingChat"></nalco-refresh-loader>
            </div>
            <div  *ngIf="(contextPointId || calledFromFsqs) && !isLoadingChat" class="messages-list">
                <div *ngFor="let message of messages; trackBy: trackByMessageId" class="message-wrapper"
                    [class.user-message]="isUserMessage(message)" [class.bot-message]="isBotMessage(message)">
                    <div class="row col-12">
                        <div class="row">
                            <div style="width: 50px;"></div>
                            <span *ngIf="isBotMessage(message)" class="message-time">{{
                                formatTimestamp(message.timestamp) }}</span>
                        </div>
                        <!-- <div class="col-1"> -->
                        <div class="row col-12">
                            <div *ngIf="isBotMessage(message)" class="layered-icon" style="width: 50px;">
                                <img class="icon-background"
                                    src="../../../../assets/images/ai-agent/Ecolab-Virtual-Agent-Chat-Logo.svg"
                                    placement="left">
                                <!-- </div> -->
                            </div>
                            <div class=" col-10 message-bubble" [ngClass]="{'user-message-bubble': isUserMessage(message), 'bot-message-bubble': isBotMessage(message),
                            'message-edit': editMessageId === message.id}"
                                (click)="isUserMessage(message) ? enableMessageEdit(message.id) : null">
                                <div *ngIf="editMessageId !== message.id" class="message-content">
                                    <app-content-renderer [content]="message.content"
                                        [enableChatStreaming]="enableChatStreaming"
                                        [isBotMessage]="message.type === 'bot'">
                                    </app-content-renderer>
                                </div>
                                <textarea *ngIf="editMessageId === message.id" class="edit-textarea"
                                    [(ngModel)]="editingMessage" (keydown)="onKeyPress($event, message.id)"
                                    placeholder="Edit your message..." rows="1"></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- <div *ngIf="(message.id && isBotMessage(message) &&
                    (feedBackSelected.didUserLike === null || (feedBackSelected.didUserLike === false && message.id == feedBackSelected.messageId)))"
                        class="row col-12">
                        <div class="feedback-container">
                            <span *ngIf="feedBackSelected.didUserLike == null" class="feedback-header-label">{{'AI_AGENT.FEEDBACK_QUESTION' | translate}}</span>
                            <span *ngIf="feedBackSelected.didUserLike == false" class="feedback-header-label">{{'AI_AGENT.FEEDBACK_DISLIKE_MESSAGE' | translate}}</span>

                            <button [disabled]="feedBackSelected.didUserLike == false" class="feedback-option-text"
                                (click)="sendFeedback(message.id, true)">
                                <span class="feedback-button-label">{{'AI_AGENT.YES' | translate}}</span>
                                <img src="../../../../assets/images/ai-agent/Icon-Action-Like.svg" alt="Like" />
                            </button>
                            <button class="feedback-option-text"
                                [ngStyle]="{'borderColor': feedBackSelected.didUserLike == false ? '#006bd3' : ''}"
                                (click)="sendFeedback(message.id, false)">
                                <span class="feedback-button-label"
                                    [ngStyle]="{'color': feedBackSelected.didUserLike == false ? '#006bd3' : ''}">{{'AI_AGENT.NO' | translate}}</span>
                                <img class="dislike-button-icon"
                                    src="../../../../assets/images/ai-agent/Icon-Action-Like.svg" alt="Like" />
                            </button>

                        </div>
                        <div style="width: inherit;">
                            <app-user-feedback *ngIf="feedBackSelected.didUserLike == false"></app-user-feedback>
                        </div>
                    </div> -->

                </div>

                <!-- Loading indicator -->
                <div *ngIf="isLoading" class="message-wrapper bot-message">
                    <div class="layered-icon" style="width: 50px;">
                        <img class="icon-background"
                            src="../../../../assets/images/ai-agent/Ecolab-Virtual-Agent-Chat-Logo.svg"
                            placement="left">
                    </div>
                    <div class="message-bubble loading">
                        <div class="message-header">
                        </div>

                        <div class="message-content">
                            <div class="typing-indicator">
                                <span class="typing-dot"></span>
                                <span class="typing-dot"></span>
                                <span class="typing-dot"></span>
                            </div>
                            <span class="typing-text">{{agentProcessingMessage}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="chat-input-container">
            <div class="input-area">
                <div class="ask-eva-container">
                    <div class="input-box" (click)="editMessageId = null">
                        <textarea id="ask-label" class="input-text" [ngClass]="{'error': noInput}" rows="1"
                            [placeholder]="currentPlaceholder" [(ngModel)]="currentMessage"
                            (keydown)="onKeyPress($event, '')" (input)="onTextareaInput($event)">
                    </textarea>

                        <!-- Buttons positioned inside textarea -->
                        <div class="input-buttons">
                            <button *ngIf="voiceSupported && !calledFromFsqs" type="button" class="speech-btn"
                                [ngClass]="{'active-recording': isRecording}" (click)="toggleRecording()"
                                [title]="isRecording ? 'Click to stop recording' : 'Click to start recording'">
                                <span class="mic-symbol" [class.pulsing]="isRecording">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20"
                                        fill="none">
                                        <path
                                            d="M7 12.7891C8.66 12.7891 10 11.4491 10 9.78906V3.78906C10 2.12906 8.66 0.789062 7 0.789062C5.34 0.789062 4 2.12906 4 3.78906V9.78906C4 11.4491 5.34 12.7891 7 12.7891ZM6 3.78906C6 3.23906 6.45 2.78906 7 2.78906C7.55 2.78906 8 3.23906 8 3.78906V9.78906C8 10.3391 7.55 10.7891 7 10.7891C6.45 10.7891 6 10.3391 6 9.78906V3.78906ZM12 9.78906C12 12.5491 9.76 14.7891 7 14.7891C4.24 14.7891 2 12.5491 2 9.78906H0C0 13.3191 2.61 16.2191 6 16.7091V19.7891H8V16.7091C11.39 16.2191 14 13.3191 14 9.78906H12Z"
                                            [attr.fill]="isRecording ? '#006BD3' : '#ADAFAF'"
                                            [attr.fill-opacity]="isRecording ? '1' : '0.65'" />
                                    </svg>
                                </span>
                            </button>

                            <button class="send-btn" (click)="sendMessage()" title="Send query">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17"
                                    fill="none">
                                    <path
                                        d="M0 16.29V0.290039L19 8.29004L0 16.29ZM2 13.29L13.85 8.29004L2 3.29004V6.79004L8 8.29004L2 9.79004V13.29Z"
                                        fill="#006BD3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div rightPanel>
        <app-chat-history-list #chatHistoryList [showAIAgent]="showAIAgent"
            (chatHistorySelected)="onChatHistorySelected($event)"></app-chat-history-list>
    </div>
</app-chat-flyout>